import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'sales-completions-customer-financial-situation',
  storeModule.createStoreModule('sales-completions-customer-financial-situation')
)
